import { changePlanPath } from './billingPaths';

/**
 * #759 D15 — qué salida ofrece a una cuenta de pago el aviso de plan agotado. La comparten el modal
 * (`UsageLimitModal`) y el aviso de «se ha parado por saldo» (`CreditStopNotice`), para que los dos
 * digan lo mismo. Vive aparte porque el aviso no debe cargar el modal (y con él el cliente HTTP).
 *
 * Con el cambio de plan, la salida la da el backend (`usage.upgrade`): subir al plan siguiente (el
 * diálogo de Facturación), contactar si el siguiente es de equipo, o soporte. Quien no gestiona la
 * facturación avisa a quien la gestiona en su org. Sin `upgrade` (interruptor apagado), el «Pedir
 * renovación» de siempre.
 */
export function limitActionOf(usage) {
  const upgrade = usage?.upgrade ?? null;
  if (!upgrade) return { kind: 'renewal' };
  if (usage?.canManageBilling !== true) return { kind: 'notify_admin' };
  if (upgrade.kind === 'change' && upgrade.planId) return { kind: 'change', planId: upgrade.planId, planName: upgrade.planName };
  if (upgrade.kind === 'checkout') return { kind: 'checkout' };
  if (upgrade.kind === 'contact' && upgrade.planId) return { kind: 'contact', planId: upgrade.planId, planName: upgrade.planName };
  return { kind: 'support' };
}

/**
 * Lo que hace esa salida pulsada fuera del modal (el aviso del corte, el menú del perfil,
 * Facturación): subir y elegir plan van directos; el resto abre el aviso, que es el que envía.
 */
export function goToLimitAction(action, { navigate, openLimitNotice }) {
  if (action.kind === 'change') navigate(changePlanPath(action.planId));
  else if (action.kind === 'checkout') navigate('/billing/required');
  else openLimitNotice?.();
}

/** El texto del botón de esa salida. `t` es el de `useTranslation`. */
export function limitButton(t, action) {
  switch (action.kind) {
    case 'change':
      return t('billing.limit.upgradeTo', { plan: action.planName, defaultValue: 'Subir a {{plan}}' });
    case 'checkout':
      return t('billing.freeAccess.choosePlan', 'Elegir un plan');
    case 'contact':
      return t('billing.enterprise.contact', 'Contactar con nosotros');
    case 'support':
      return t('billing.limit.contactSupport', 'Contactar con soporte');
    case 'notify_admin':
      return t('billing.limit.notifyAdmin', 'Avisar a tu administrador');
    default:
      return t('billing.limit.requestRenewal', 'Pedir renovación');
  }
}
